const Enumeration = window['Enumeration'];

export const TimeWindowEnum = Enumeration('TimeWindowEnum', {
  DAY: {
    moment: 'day',
    heading: function () {
      return '';
    }
  },
  WEEK: {
    moment: 'week',
    heading: function () {
      return '';
    }
  },
  MONTH: {
    moment: 'month',
    heading: function () {
      return '';
    }
  },
  QUARTER: {
    moment: 'quarter',
    heading: function () {
      return '';
    }
  },
  YEAR: {
    moment: 'year',
    heading: function () {
      return '';
    }
  }
});



// WEBPACK FOOTER //
// ./app/vendor/utility-js-time/src/enums/time_window_enum.ts